function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from "react";
import * as ReactDOM from "react-dom";
import * as Api from "../ajax/PrintApi";
import IntlMessage from '../commons/Intl';
import { Action, Description, Print } from '../commons/IntlMessages';
var defaultLanguage = 'ja';
var intl = new IntlMessage(defaultLanguage);
var language = window.navigator.language.substring(0, 2) === 'ja' ? 'ja' : 'en';
intl.setLanguage(language);
/**
 * メインコンポーネント
 */

var MainComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(MainComponent, _React$Component);

  var _super = _createSuper(MainComponent);

  /**
   * フィールド変数の初期化を行います。
   *
   * @param props プロップス
   */
  function MainComponent(props) {
    var _this;

    _classCallCheck(this, MainComponent);

    _this = _super.call(this, props);
    _this.state = {
      Offset: null
    };

    _this.setParam();

    return _this;
  }
  /**
   * 配置用QRコード取得
   */


  _createClass(MainComponent, [{
    key: "setParam",
    value: function setParam() {
      var _this2 = this;

      if (!window.opener) return;
      var receiveJson = window.opener.$('#offset').val() || "";
      if (receiveJson == null || receiveJson == undefined) return;
      var receive = JSON.parse(receiveJson);
      Api.GetQrCode(receive.OffsetX, receive.OffsetY, receive.OffsetZ, 0, function (model) {
        _this2.setState({
          Offset: receive
        });

        var qrmessage = $('#qrmessage');

        if (qrmessage) {
          qrmessage.hide();
        }

        var qrcodeframe = $('#qrcodeframe');

        if (qrcodeframe) {
          qrcodeframe.show();
          var qucode = $('#qrcode');

          if (qucode) {
            qucode.attr('src', 'data:image/png;base64,' + model.Code);
          }
        }

        var qrcodeharfframe = $('#qrcodeharfframe');

        if (qrcodeharfframe) {
          qrcodeharfframe.show();
        }
      });
    }
    /**
     * 「印刷」ボタン押下時の処理を行います。
     */

  }, {
    key: "onPrint",
    value: function onPrint() {
      window.print();
    }
    /**
     * ComponentがDOMツリーに追加された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.common.bind();
      this.adjustStyle();
    }
    /**
     * スタイルの調整
     */

  }, {
    key: "adjustStyle",
    value: function adjustStyle() {
      var mainHeader = $('.main-header');

      if (mainHeader) {
        mainHeader.removeClass('main-header');
        mainHeader.removeClass('navbar');
      }

      var mainSidebar = $('.main-sidebar');

      if (mainSidebar) {
        mainSidebar.removeAttr('style');
      }

      var contentWrapper = $('.content-wrapper');

      if (contentWrapper) {
        contentWrapper.removeAttr('style');
      }
    }
    /**
     * ComponentがDOMツリーから削除された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {}
    /**
     * レンダラー
     */

  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, this.state.Offset && this.state.Offset.Title != "" && [/*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "header__wrapper"
      }, /*#__PURE__*/React.createElement("div", {
        className: "header__content"
      }, /*#__PURE__*/React.createElement("h1", {
        className: "header__title"
      }, this.state.Offset.Title)))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "message print"
      }, intl.format(Description.PlacementQrCodeDescription)), /*#__PURE__*/React.createElement("div", {
        className: "messageprint noprint"
      }, intl.format(Description.PlacementQrCodeDescriptionPrint)), /*#__PURE__*/React.createElement("div", {
        className: "qrframe justify-content-center"
      }, /*#__PURE__*/React.createElement("div", {
        id: "qrmessage",
        className: "nocode noprint"
      }, intl.format(Print.NoCodeMessage)), /*#__PURE__*/React.createElement("div", {
        id: "qrcodeframe",
        className: "qrcodeframe",
        style: {
          display: "none"
        }
      }, /*#__PURE__*/React.createElement("img", {
        id: "qrcode",
        className: "qrcode",
        src: "/assets/img/noimage.png",
        alt: "PlacementQR"
      })), /*#__PURE__*/React.createElement("div", {
        id: "qrcodeharfframe",
        className: "qrcodeharfframe",
        style: {
          display: "none"
        }
      }, /*#__PURE__*/React.createElement("img", {
        id: "qrcode",
        className: "qrcode",
        src: "/assets/img/AnchorQR.png",
        alt: "PlacementQR"
      }))))), /*#__PURE__*/React.createElement("div", {
        className: "action justify-content-center"
      }, /*#__PURE__*/React.createElement("button", {
        key: "onPrint",
        type: "button",
        className: "btn btn-primary noprint",
        onClick: this.onPrint.bind(this),
        tabIndex: 100
      }, intl.format(Action.Print)))]);
    }
  }]);

  return MainComponent;
}(React.Component);
/**
 * レンダラー
 *
 * @param el バインド対象
 * @param common 共通
 */


export default function (el, common) {
  ReactDOM.render( /*#__PURE__*/React.createElement(MainComponent, {
    common: common
  }), el);
}